import { useMemo, useState } from 'react';

import { getCryptoAccountNumbers } from 'utils/accounts/getCryptoAccountNumbers';
import { hasValue } from 'utils/hasValue';

import { useGetCollectionFundingInstructions, useGetCryptoC2cToken } from 'api';

import { useOrganisationId, useVirtualAccounts } from 'hooks/context';

import { C2CCryptoIframe } from './C2CCryptoIframe';

import { Loading } from '../../Loading';
import { CryptoFundingAccountLayout } from '../CryptoFundingAccountLayout';
import { CryptoFundingEmptyStateContainer } from '../CryptoFundingEmptyStateContainer';

export const C2CCryptoFundingContent = () => {
  const organisationId = useOrganisationId<number>();
  const [accountNumber, setAccountNumber] = useState<string>();

  const { data: { data: fundingInstructions } = {}, isSuccess } =
    useGetCollectionFundingInstructions(Number(organisationId));
  const { accounts: virtualAccounts } = useVirtualAccounts();

  const cryptoAccounts = useMemo(() => {
    if (
      !isSuccess ||
      !hasValue(fundingInstructions) ||
      !hasValue(virtualAccounts)
    )
      return [];

    const cryptoAccountNumbers = getCryptoAccountNumbers(fundingInstructions);

    return virtualAccounts.filter((account) =>
      cryptoAccountNumbers.has(account.account_number)
    );
  }, [fundingInstructions, isSuccess, virtualAccounts]);

  const { data: { data: c2cToken } = {}, isSuccess: isTokenSuccess } =
    useGetCryptoC2cToken(
      organisationId,
      { virtual_account_number: accountNumber! },
      {
        query: { enabled: hasValue(accountNumber) }
      }
    );

  if (!cryptoAccounts.length) {
    return <Loading className="!h-20" />;
  }

  return (
    <CryptoFundingAccountLayout
      accounts={cryptoAccounts}
      setAccountNumber={setAccountNumber}
    >
      {isTokenSuccess && hasValue(accountNumber) && c2cToken ? (
        <div className="flex w-full">
          <C2CCryptoIframe
            endpoint="rfq-wallets"
            token={c2cToken}
            className="-ml-2.5"
          />
          <C2CCryptoIframe
            endpoint="history"
            token={c2cToken}
            className="-mr-2.5"
          />
        </div>
      ) : (
        <CryptoFundingEmptyStateContainer className="h-80 w-full" />
      )}
    </CryptoFundingAccountLayout>
  );
};
